import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse} from 'axios';
import { EpaApi } from '../../../services';
import { IWellWaterSystemsData, WellWaterSystemsInitialState } from '../wellWaterSystems.slice';

export const fetchWellWaterSystemsAsync = createAsyncThunk(
    'systems/fetchSystems',
    async ({ zips }: { zips: string },
   { rejectWithValue },) => {
      try {
        const response = await EpaApi.fetchWellWaterSystems(zips);
        return (response as AxiosResponse<any,any>).data;
      } catch (error: any) {
        console.error(error);
        return rejectWithValue({
          message: error?.response?.data?.message || "Unexpected error occurred"
        });
      }
    }
  );

export const fetchWellWaterSystemsAsyncBuilder = (
    builder: ActionReducerMapBuilder<WellWaterSystemsInitialState>
  ) => {
    builder.addCase(fetchWellWaterSystemsAsync.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = '';
    })
    builder.addCase(
      fetchWellWaterSystemsAsync.fulfilled,
      (state, action: PayloadAction<IWellWaterSystemsData>) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      }
    )
    builder.addCase(
      fetchWellWaterSystemsAsync.rejected,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      }
    )
  }